import { render, staticRenderFns } from "./ChatQuoteMessage.vue?vue&type=template&id=cbba44be&scoped=true"
import script from "./ChatQuoteMessage.vue?vue&type=script&lang=js"
export * from "./ChatQuoteMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatQuoteMessage.vue?vue&type=style&index=0&id=cbba44be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba44be",
  null
  
)

export default component.exports